import React, { useState, useEffect, useRef } from "react";
import { motion, useTransform, useViewportScroll } from 'framer-motion';
import CSIntroImage1 from "../../images/cd-ht-intro-image-1.jpeg";
import CSIntroImage2 from "../../images/cd-ht-intro-image-2.svg";
import Parallax from "../common/utils/animations/parallax";

export default function CsIntro(props) {
  return (
    <div className="cs-intro-section section-gap ht-intro">
      <div className="container-small">
        <div className="intro-inner">
          <h3>Challenge</h3>
          <p>Harris Teeter (‘HT’) is one of the largest grocery chains in the southeast United States with millions of customers and billions of dollars in revenue.</p>
          <p>With the digital wave disrupting the retail industry, Harris Teeter wanted to be the market  leader by reshaping customer experiences across all channels - web, mobile, email and stores.</p>
        </div>

        <div className="cs-intro-image">
          <Parallax id="ht-intro-image-cs-1" triggers={[1, 0.7]} opacity={true} length={100}>
            <motion.img src={CSIntroImage1} className="intro-large-image" title="digital in-store transformation" alt="digital transformation retail industry" />
          </Parallax>
          <Parallax id="ht-intro-image-cs-2" triggers={[1, 0.7]} opacity={true} length={100}>
            <motion.img src={CSIntroImage2} className="intro-small-image" title="digital in-store transformation" alt="digital transformation retail industry" />
          </Parallax>
          <p>Harris Teeter’s old mobile and website experiences.</p>
        </div>

        <div className="intro-inner">
          <p>Harris Teeter’s digital infrastructure was fragmented with legacy systems, third-party apps, and old user interfaces. Many systems were rigid and prevented HT from using the latest tech, design, and data to deliver personalized and connected experiences that could transform their business. Harris Teeter partnered with us to deliver on the digital ambitions that later made them a leader in digital retail. </p>
        </div>

      </div>
    </div>
  );
}